import AXIOS from '@/axios-instance';
import store from "@/store.js"

export default {

  generateShareToken(uuid){
    return AXIOS.post("/bpmn/"+uuid+"/link");
  },
  getShareLinkIfExists(uuid){
    return AXIOS.get("/bpmn/"+uuid+"/link");
  },
  uploadFileAsText(uuid, content) {
    return AXIOS.put("/share/" + uuid,
      content);
  },
  getProcessXml(uuid) {
    return AXIOS.get("/share/" + uuid);
  },
  retrieveModelInformation(uuid) {
    return AXIOS.get("/share/" + uuid+"/information");
  },
  getElementsWithAttachments(uuid){
    return AXIOS.get("/bpmn/"+uuid+"/attachments");
  },
  setEditingMode(uuid, userId) {
    return AXIOS.post("/share/" + uuid + "/editMode",
      {
        currentEditor: userId
      });
  },
}
